import { mapState, mapGetters, mapActions } from "vuex";
import CustomSideBarAppModal from "@/components/CustomSideBarAppModal";
import AppModal from "@/components/AppModal";
import AppIcon from "@/components/AppIcon";
import AppPopover from "@/components/AppPopover";
import AppButton from "@/components/AppButton";
import WrapWithCopy from "@/components/WrapWithCopy.vue";
import TasksMixin from "@/mixins/TasksMixin.vue";
import { country_codes, country_codes_flipped } from "@/utils/countries";
import AccountsMixin from "@/mixins/AccountsMixin.vue";
export default {
  name: "DSPAccountSideBar",
  emits: ["refresh"],
  mixins: [TasksMixin, AccountsMixin],
  components: {
    CustomSideBarAppModal,
    AppIcon,
    AppModal,
    AppButton,
    WrapWithCopy,
    AppPopover
  },
  props: {
    account: {
      type: Object,
      default: () => ({})
    },
    account_type: {
      type: String,
      default: ""
    },
    profiles: {
      type: Array,
      default: []
    },
    advertisers: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      confirmRemoveModal: false,
      removeLoading: false,
      removeId: null,
      removeList: [],
      accountRemoveTaskIdentifier: "",
      removeAccount: {},
      removeProfiles: []
    };
  },
  computed: {
    ...mapGetters(["getCountryFlag"]),
    ...mapState({
      me: state => state.auth.me,
      isOmnyWorkspace: state => state.workspace.isOmnyWorkspace,
      current_workspace: state => state.workspace.current_workspace
    })
  },
  mounted() {
    this.checkIfAnyPreviousAccountRemoveTaskIsRunning();
  },
  methods: {
    ...mapActions(["accountAuthorize", "accountRemove"]),
    onRemoveAdvertiserProfile(profile) {
      this.removeId = profile.account_id;
      this.removeAccount = profile;
      this.removeProfiles = [profile];
      this.removeList = [{
        account_id: profile.account_id.toString()
      }];
      this.confirmRemoveModal = true;
    },
    onRemoveAgencyProfile(profile) {
      this.removeId = profile.account_id;
      this.removeAccount = profile;
      let advertiser_for_agency = this.amazonDSPAdvertiserProfilesForAgencyProfile(profile);
      this.removeProfiles = [profile, ...advertiser_for_agency];
      this.removeList = this.removeProfiles.map(item => {
        return {
          account_id: item.account_id.toString()
        };
      });
      this.confirmRemoveModal = true;
    },
    handleIdle() {
      this.removeLoading = false;
    },
    handleFailed() {
      this.removeLoading = false;
    },
    handleRunning() {
      this.removeLoading = true;
      this.checkTaskStatusPeriodically(this.accountRemoveTaskIdentifier);
    },
    handleFinished(data) {
      this.removeLoading = false;
      this.removeId = null;
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      ;
      window.$bus.trigger("showSuccess", {
        visible: true,
        message: data.task_status + data.task_result.status,
        delay: 60 // Show alert less than 1 minute
      });
      this.$emit("refresh", {
        "account_id": this.account.account_id,
        "type": this.account_type
      });
    },
    checkIfAnyPreviousAccountRemoveTaskIsRunning() {
      for (const profile in this.profiles) {
        this.removeId = profile.account_id;
        this.accountRemoveTaskIdentifier = this.current_workspace.workspace_id + "_" + profile.account_id + "_" + "accounts_delete";
        this.getAsyncUpdate(this.accountRemoveTaskIdentifier);
        this.checkTaskStatusPeriodically(this.accountRemoveTaskIdentifier);
        for (const advertiser in this.amazonDSPAdvertiserProfilesForAgencyProfile(profile)) {
          this.removeId = advertiser.account_id;
          this.accountRemoveTaskIdentifier = this.current_workspace.workspace_id + "_" + advertiser.account_id + "_" + "accounts_delete";
          this.getAsyncUpdate(this.accountRemoveTaskIdentifier);
          this.checkTaskStatusPeriodically(this.accountRemoveTaskIdentifier);
        }
      }
      ;
    },
    async onRemoveConfirm() {
      this.confirmRemoveModal = false;
      this.removeLoading = true;
      this.accountRemoveTaskIdentifier = this.current_workspace.workspace_id + "_" + this.removeId + "_" + "accounts_delete";
      let account_remove_task = await this.accountRemove({
        seller_list: this.removeList,
        task_identifier_omny: this.accountRemoveTaskIdentifier,
        workspace_id: this.current_workspace.workspace_id.toString()
      });
      this.getAsyncUpdate(account_remove_task.task_id);
      this.checkTaskStatusPeriodically(account_remove_task.task_id);
    },
    async onConnect() {
      const data = {
        region: this.account.region,
        account_provider: "Amazon DSP Advertising",
        workspace_id: this.account.workspace_id,
        amz_sp_api_seller_id: this.account.selling_partner_id,
        account_type: "agency"
      };
      this.loading = true;
      await this.accountAuthorize(data);
      this.loading = false;
    },
    flipCountry(country) {
      return country_codes_flipped[country];
    }
  }
};